import React from 'react'
import EditGroupWorker from './edit'
import { Link, withRouter } from 'react-router-dom'
import GroupForm from '../../../../components/journal/groups/form/form.component'
import FormHelper from '../../../../utils/FormHelper'
import Dialog from '../../../../components/dialog/dialog.component'
import Loading from '../../../../components/loading/loading.component'

class EditGroup extends React.Component {
    
    constructor() {
        super()
        this.editGroupWorker = EditGroupWorker(this)
        this.state = this.editGroupWorker.getDefaultState()
    }

    componentDidMount = () => {
        this.editGroupWorker.loadGroup()
    }

    onSubmit = (e) => {
        e.preventDefault()
        this.editGroupWorker.isValid() && this.editGroupWorker.updateGroup()
    }

    onCancel = () => this.props.history.push('/journal/groups')

    render(){
        return(
            <div className="edit-group">
                {
                    this.state.loadingGroup && <Dialog><Loading /></Dialog>
                }
                <div className="card">
                    <Link className="btn" to="/journal/groups">Groups</Link>
                    <div className="header">
                        <h4>Edit Group</h4>
                    </div>
                    <div className={"flag " + this.state.flag.type}>
                        {this.state.flag.text}
                    </div>
                    <GroupForm {...this.state} action="Save Group" onChange={FormHelper(this).onChange} onSubmit={this.onSubmit} onCancel={this.onCancel}/>
                </div>
            </div>
        )
    }
}

export default withRouter(EditGroup)